import { env } from 'utils/envManager'

import type { SizeGuideEquivalencesList } from '../../../types/SizeGuide.types'
import { sortEquivalences } from '../../../utils/sortEquivalences/sortEquivalences'

export interface GetClientEquivalencesProps {
	languageISO: string
	familyId: string
}

export async function getClientEquivalences({
	languageISO,
	familyId,
}: GetClientEquivalencesProps): Promise<{
	equivalences: SizeGuideEquivalencesList[]
}> {
	const urlPath = `/ws-size-guide/sizeguide/equivalences/${languageISO}/${familyId}`

	const url = new URL(urlPath, env.NEXT_PUBLIC_SITE_BASE_URL)

	const fetchedEquivalences = (await fetch(url.href, {
		next: { revalidate: 0 },
	}).then((response) => response.json())) as SizeGuideEquivalencesList[]

	const equivalences = sortEquivalences(fetchedEquivalences)

	return { equivalences }
}
